"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeProps = void 0;
var engine_types_1 = require("@verified/c11-engine.types");
var serializeProps = function (props, serializers) {
    var serialized = Object.keys(props).reduce(function (acc, x) {
        var result = serializers.reduce(function (acc, y) {
            if (y.type && y.type !== engine_types_1.GraphNodeType.EXTERNAL) {
                return acc;
            }
            if (y.name && y.name !== x) {
                return acc;
            }
            var specificity = 1;
            if (y.type === engine_types_1.GraphNodeType.EXTERNAL) {
                specificity += 1;
            }
            if (y.name === x) {
                specificity += 1;
            }
            if (y.instanceof && props[x] instanceof y.instanceof) {
                specificity += 1;
            }
            var value = y.serializer(props[x]);
            if (value === undefined) {
                return acc;
            }
            if (acc.specificity && acc.specificity > specificity) {
                return acc;
            }
            if (acc.specificity === specificity) {
                console.warn("serializer conflict, deep equality will be used instead for", x);
                return {};
            }
            acc = {
                specificity: specificity,
                value: value,
            };
            return acc;
        }, {});
        if (result.value) {
            acc[x] = result.value;
        }
        return acc;
    }, {});
    var nonSerialized = Object.keys(props).reduce(function (acc, x) {
        if (!serialized[x]) {
            acc[x] = props[x];
        }
        return acc;
    }, {});
    return {
        serialized: serialized,
        nonSerialized: nonSerialized,
    };
};
exports.serializeProps = serializeProps;
//# sourceMappingURL=data:application/json;base64,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